<template>
 <div class="new-index">
   <div class="mask-img" :style="{opacity: loading?1:0}">
     <img class="mask-bg" src="../../assets/image/loading.png"/>
     <img class="logo" src="../../assets/image/loadingLogo.png"/>
<!--     <img class="logo" src="../../assets/logo-index.png"/>-->
   </div>
   <div style="height: 100%;width: 100%;  overflow: hidden;" v-show="!loading">
     <nav>
       <TopNav />
     </nav>
     <video  id=”media” :src="videoUrl" autoplay loop  muted :poster="require('../../assets/image/indexBg.jpg')"></video>
<!--     <div class="more">-->
<!--       了解更多-->
<!--     </div>-->
   </div>
   <Footer v-show="!loading"/>
 </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "Index",
  components: {
    Footer,
    TopNav
  },
  data() {
    return {
      videoUrl: 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/owe/prod/home/mote.mp4',
      autoplay: '',
      loading: true,
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    },2000)
  },
  methods: {

  }
}
</script>
<style lang="less"  scoped>
.new-index {
  height: 100%;
  font-size: 14px;
  .mask-img {
    height: 99%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: opacity 240ms ease-in-out;
    .mask-bg {
      height: 100%;
      width: 100%;
    }
    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
  video {
    height: 100%;
    width: 100%;
    margin: 0;
    display: block;
    object-fit: fill;
  }
  .more {
    border: 1px solid #ffffff;
    border-radius: 10px;
    color: #ffffff;
    padding: 11px 92px;
    position: absolute;
    bottom: 60px;
    font-size: 26px;
    left: 50%;
    transform: translate(-50%,0);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/Index.vue